import { render, staticRenderFns } from "./CbsCustomHtmlForm.vue?vue&type=template&id=0edb260d&scoped=true"
import script from "./CbsCustomHtmlForm.vue?vue&type=script&lang=js"
export * from "./CbsCustomHtmlForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb260d",
  null
  
)

export default component.exports